import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Question, Response} from '../../model/GeneralModels';
import {GeneralService} from '../../services/general.service';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: [
    '../../assets/vendor/mdi-font/css/material-design-iconic-font.min.css',
    '../../assets/Content/src/css/lib.vendor.css',
    '../../assets/Content/src/css/lib.picker.css',
    '../../assets/Content/src/css/ini.bime.css',
    '../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../assets/css/light.theme.css'
  ]
})
export class FormComponent implements OnInit {
  @Input() productName: string;
  @Input() formGroup: FormGroup;
  @Input() questions: any[];
  @Input() viewList: any = {};
  @Input() translation: any = {};
  questionList: Question[] = [];

  constructor() {
  }

  ngOnInit() {
    this.questions.forEach(question => {
      const index = this.questionList.length;
      this.questionList[index] = new Question(question, this.formGroup);
    });
  }
}
